import { Snackbar, SnackbarLink } from '@tkww/orion-web-ds-feedback';
import '@xo-union/tk-ui-essentials';
import { LayoutRoot } from '@xo-union/ui-accessibility';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { setIsOpen } from '../../redux/alert';
import { GlobalTemplate } from './GlobalTemplate';
import HelmetImagePreloadRenderer from './HelmetImagePreloadRenderer';
import Styles from './styles.scss';

const Layout = (props) => {
	const {
		route: { routes },
		closeAlert,
		alertState,
		isMobileApp,
	} = props;
	const alert = useRef(null);

	useEffect(() => {
		const { content, link, isOpen } = alertState;
		if (isOpen && alert.current) {
			if (link) {
				alert.current.showAndDismiss({
					data: {
						content,
						href: link.href,
						linkText: link.linkText,
						type: 'WITH_LINK',
					},
					dismissTimeout: 6000,
				});
				return;
			}
			alert.current.showAndDismiss({
				data: {
					content,
					type: 'NO_LINK',
				},
				dismissTimeout: 6000,
			});
			closeAlert();
		}
	}, [alertState.isOpen]);

	return (
		<HelmetImagePreloadRenderer>
			<div>
				<div className={Styles.alert}>
					<Snackbar
						ref={(snackbar) => {
							if (snackbar && alertState.isOpen) {
								snackbar.show({
									data: {
										message: alertState.content,
										link: alertState.link
											? {
													label: alertState.link.linkText,
													href: alertState.link.href,
												}
											: null,
									},
								});
							}
						}}
					>
						{(data) => (
							<span>
								{data.message}{' '}
								{data.link && (
									<SnackbarLink
										href={data.link.href}
										className={Styles.snackbarLink}
									>
										{data.link.label}
									</SnackbarLink>
								)}
							</span>
						)}
					</Snackbar>
				</div>
				<GlobalTemplate isMobileApp={isMobileApp}>
					<LayoutRoot>
						<div className={Styles.contentContainer}>
							<div className="render-route-container" suppressHydrationWarning>
								{renderRoutes(routes)}
							</div>
						</div>
					</LayoutRoot>
				</GlobalTemplate>
			</div>
		</HelmetImagePreloadRenderer>
	);
};

Layout.propTypes = {
	route: PropTypes.shape({
		routes: PropTypes.array.isRequired,
	}).isRequired,
	closeAlert: PropTypes.func.isRequired,
	alertState: PropTypes.shape({
		link: PropTypes.shape({
			href: PropTypes.string.isRequired,
			linkText: PropTypes.string.isRequired,
		}),
		isOpen: PropTypes.bool.isRequired,
		content: PropTypes.oneOfType([
			PropTypes.arrayOf(PropTypes.node),
			PropTypes.node,
			PropTypes.oneOf([null]),
		]),
	}).isRequired,
	isMobileApp: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
	alertState: state.alert,
	isMobileApp: state.viewport.isMobileApp,
});

const mapDispatchToProps = (dispatch) => ({
	closeAlert: () => dispatch(setIsOpen(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
